export function structureTable(root) {
  if (!root) return;

  root.querySelectorAll('table').forEach((table) => {
    const explicitRowHeader = table.classList.contains('table-row-header');
    const explicitColHeader = table.classList.contains('table-col-header');

    table.classList.add('cms-table');
    table.classList.remove('table-row-header', 'table-col-header');
    table.removeAttribute('align');
    table.removeAttribute('border');
    table.removeAttribute('cellpadding');
    table.removeAttribute('cellspacing');
    table.style.width = '';

    if (explicitRowHeader) {
      table.classList.add('table-row-header');
    } else if (explicitColHeader) {
      table.classList.add('table-col-header');
    } else {
      const hasThead = !!table.querySelector('thead');
      table.classList.add(hasThead ? 'table-row-header' : 'table-col-header');
    }
  });
}
